import { BaseToolbarProps } from '../../core/types/toolbar.js';

export const Toolbar = (props: BaseToolbarProps) => null;

Toolbar['displayName'] = 'TreeMap.Toolbar';
